import React, { useEffect } from 'react';
import { Modal as AntModal } from 'antd';
import { SuccessCard } from '../../../components';
import styled from 'styled-components';

const Modal = styled(AntModal)`

.ant-modal-content {
    padding: 0;
    border-radius: 24px;
}
`;

const SuccessModal = ({
    open,
    handleClose,
}) => {

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                handleClose();
            }, 2000);
        }

        // eslint-disable-next-line
    }, [open]);

    return (
        <Modal
            centered
            closable={false}
            footer={false}
            open={open}
        >
            <SuccessCard title="Password Sent to Email" />
        </Modal>
    )
}

export default SuccessModal